<template>
  <div>
    <component-new-header
      title="Create Bulk Promotion"
      :isLoading="loading"
      :hasSearch="false"
      :hasReload="false"
      :hasRadio="false"
      :hasCreate="false"
      :hasback="true"
      @back-press="$router.push('/bulkPromotion')"
    />
    <b-card class="cardStyle">
      <b-row class="entity-criteria-top-row">
        <b-col md="6">
          <b-row class="align-items-center">
            <b-col md="12">
              <h5 class="text-primary mb-2">Select Entity</h5>
            </b-col>
            <b-col cols="12" class="d-flex align-items-center">
              <eb-select
                class="select-background-white w-100"
                id="text"
                type="text"
                label="text"
                placeholder="Select Entity"
                :options="entityOptions"
                v-model="entity"
                @input="selectEntityType"
              >
              </eb-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6">
          <b-row class="align-items-center">
            <b-col md="12">
              <h5 class="text-primary mb-2">Select Criteria</h5>
            </b-col>
            <b-col cols="12" sm="10" md="10" class="mb-2 mb-sm-0 d-flex align-items-center">
              <eb-select
                class="select-background-white w-100"
                id="text"
                type="text"
                label="text"
                placeholder="Select Criteria"
                :options="criteriaOptions"
                v-model="selectedCriteriaOptions"
                :selected="selectedCriteriaOptions"
              >
              </eb-select>
            </b-col>
            <b-col cols="12" sm="2" md="2" class="mb-2 mb-sm-0 d-flex align-items-center justify-content-center justify-content-md-end">
              <b-button
                :disabled="disableCriteria"
                @click="addCriteriaData(selectedCriteriaOptions)"
                variant="success"
                class="circularBtn criteria-add-btn"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row v-for="(option, index) in selectedCriteriaOption" :key="index" class="criteria-row align-items-center">
        <b-col md="6" class="mb-2 mb-md-0 criteria-left-col">
          <b-row class="align-items-center">
            <b-col cols="12" sm="4" md="3" class="mb-2 mb-md-0">
              <label class="criteria-label mb-0" :for="`operator${index}`">{{ option.text }}</label>
              <label hidden :for="`operator${index}`">{{ (criteria[index] = option.value) }}</label>
            </b-col>
            <b-col cols="12" sm="8" md="9" class="mb-2 mb-md-0">
              <eb-select
                class="w-100"
                :id="`selectedOperator${index}`"
                type="text"
                label="text"
                placeholder="Select Operator"
                :options="allOperatorOptions(option, index)"
                v-model="selectedOperator[index]"
                :selected="selectedOperator[index]"
              >
              </eb-select>
            </b-col>
          </b-row>
        </b-col>
        <b-col md="6" class="mb-2 mb-md-0 criteria-right-col">
          <b-row class="align-items-center">
            <b-col cols="12" sm="10" md="10" class="mb-2 mb-sm-0">
          <b-form-input
            class="input-placeholder-right w-100 criteria-input"
            v-if="
              option.value !== 'age' &&
              option.value !== 'date' &&
              option.value !== 'orderAmount'
            "
            :id="`operator${index}`"
            :placeholder="`Enter ${option.text}`"
            v-model="inputData[index]"
          >
          </b-form-input>

          <b-row class="age-row-padding" v-if="option.value === 'age'">
            <range-Slider
              :id="`inputId${index}`"
              v-model="rangeValue"
              @minValue="onMinRangeChange"
              @maxValue="onMaxRangeChange"
            ></range-Slider>
            <b-form-input
              hidden
              :id="`inputId${index}`"
              :v-model="(inputData[index] = rangeValue)"
            >
            </b-form-input>
          </b-row>

          <b-row v-if="option.value === 'orderAmount'" class="order-amount-row">
            <b-col md="6" class="order-amount-col">
              <b-input
                :id="`start-date${index}`"
                type="number"
                placeholder="Lower Amount"
                v-model="startDate"
                @input="selectDate"
                class="form-control"
              ></b-input>
            </b-col>
            <b-col md="6" class="order-amount-col">
              <b-input
                :id="`end-date${index}`"
                type="number"
                placeholder="Higher Amount"
                v-model="endDate"
                @input="selectDate"
                class="form-control"
              ></b-input>
            </b-col>
            <b-form-input
              hidden
              :id="`inputId${index}`"
              :placeholder="`Select ${option.text}`"
              :v-model="(inputData[index] = startEndDate)"
            >
            </b-form-input>
          </b-row>

          <b-row v-if="option.value === 'date'" class="date-inputs-row align-items-center flex-nowrap">
            <b-col cols="6" class="date-input-col pr-1">
              <b-input
                :id="`start-date${index}`"
                type="date"
                v-model="startDate"
                @input="selectDate"
                class="form-control date-input"
              ></b-input>
              <span class="validate-error" v-if="startDate && !validStartDate">
                Start Date is not valid
              </span>
            </b-col>
            <b-col cols="6" class="date-input-col pl-1">
              <b-input
                :id="`end-date${index}`"
                type="date"
                v-model="endDate"
                @input="selectDate"
                class="form-control date-input"
              ></b-input>
              <span class="validate-error" v-if="endDate && !validEndDate">
                End Date is not valid
              </span>
              <b-form-input
                hidden
                :id="`inputId${index}`"
                :placeholder="`Select ${option.text}`"
                :v-model="(inputData[index] = startEndDate)"
              >
              </b-form-input>
            </b-col>
          </b-row>
            </b-col>
            <b-col cols="12" sm="2" md="2" class="d-flex align-items-center justify-content-center mb-2 mb-sm-0 criteria-minus-btn-col">
              <b-button
                @click="removeCriteria(index)"
                variant="success"
                class="circularBtn"
              >
                <i class="fa fa-minus" aria-hidden="true"></i>
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="my-4 view-impacted-row">
        <b-col cols="12" class="text-center ">
          <b-button
            :disabled="selectedCriteriaOption == []"
            @click="viewImpactedCustomer"
            variant="primary"
            class="view-impacted-btn"
            >VIEW IMPACTED CUSTOMER</b-button
          >
        </b-col>
      </b-row>
    </b-card>
    <b-row class="my-4 impacted-buttons-row align-items-center">
      <b-col cols="12" sm="6" md="6" class="mb-2 mb-md-0 d-flex align-items-center">
        <span class="impacted-cust"
          >Impacted Customer ({{ getNewCriteria.total || 0 }})
        </span>
      </b-col>
      <b-col cols="12" sm="6" md="6" class="mb-2 mb-md-0 d-flex align-items-center justify-content-sm-end">
        <b-button
          @click="downloadDetails"
          variant="outline-primary"
          class="download-btn"
        >
          <i class="fa fa-file-text-o mx-2" aria-hidden="true"></i>Download
        </b-button>
      </b-col>
    </b-row>
    <b-card class="cardStyle promo-config-card">
      <h4 class="text-primary section-title">Promotional Configuration</h4>
      <b-row class="promo-config-row">
        <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
          <eb-select
            type="text"
            label="text"
            placeholder="Promotion Type"
            :options="typeOfNotificationOption"
            v-model="promoType"
            :selected="promoType.text"
            @input="templateTypeList"
          ></eb-select>
        </b-col>
        <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
          <eb-select
            type="text"
            label="text"
            placeholder="Notification Type"
            :options="typeOfNotificationOption"
            v-model="notificationOption"
            :selected="notificationOption.text"
            @input="templateTypeList"
          ></eb-select>
        </b-col>
      </b-row>
      <b-row class="promo-config-row">
        <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
          <eb-select
            type="text"
            label="text"
            placeholder="Choose Template"
            :options="templateOptionList"
            v-model="templateOption"
            :selected="templateOption.text"
            @input="previewSelectedTemplate"
          ></eb-select>
        </b-col>
        <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
    <b-form-input
      type="number"
      placeholder="Promotion Amount"
      class="promo-input"
      v-model="promoAmount"
    ></b-form-input>
  </b-col>
      </b-row>
      <b-row class="promo-config-row preview-template-row">
        <b-col cols="12">
          <div
            contentEditable="false"
            placeholder="Preview Template"
            class="previewTemplate"
            v-html="showPreviewHere"
          ></div>
        </b-col>
      </b-row>
      <b-row class="timestamp-row">
        <b-col cols="12" sm="12" md="6" class="mb-2 mb-md-0">
          <b-form-input
            placeholder="Description"
            v-model="description"
          ></b-form-input>
        </b-col>
        <b-col cols="12" sm="4" md="2" class="mb-2 mb-md-0">
          <b-input
            disabled
            type="text"
            label="label"
            placeholder="Choose Effective Timestamp"
          ></b-input>
        </b-col>
        <b-col cols="12" sm="4" md="2" class="mb-2 mb-md-0">
          <b-input
            id="time-stamp"
            type="date"
            v-model="timestampDate"
          ></b-input>
        </b-col>
        <b-col cols="12" sm="4" md="2" class="mb-2 mb-md-0">
          <b-input
            id="time-stamp"
            type="time"
            v-model="timestampTime"
          ></b-input>
        </b-col>
      </b-row>
      <b-row class="my-2">
        <b-col cols="12" class="text-center">
          <h5 class="impactValueStyle mb-3">
            Total Impacted value : {{ promoAmount * (getNewCriteria.total || 0) }}
          </h5>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="12" md="auto" class="text-center">
          <b-button
            @click="createBulkNotification"
            variant="primary"
            class="submit-btn-custom"
            >SUBMIT</b-button
          >
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import ComponentNewHeader from "@/components/componentNewHeader";

import rangeSlider from "@/components/FormElements/Slider.vue";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  components: { ebSelect, evSelect, rangeSlider, ComponentNewHeader },
  data() {
    return {
      loading: false,
      sliderValue: 500,
      entity: "",
      promoAmount: "",
      promoType: "",
      previewScreen: "",
      description: "",
      myToggle: false,
      rangeValue: { gte: "", lte: "" },
      max: 100,
      startDate: "",
      endDate: "",
      startEndDate: "",
      selectedCriteriaOptions: "",
      selectedCriteriaOption: [],
      operatorOptions: [],
      selectedOperator: [],
      inputData: [],
      criteria: [],
      entityOptions: [
        {
          text: "Lead Customer",
          value: "LEADCUSTOMER"
        },
        {
          text: "Order",
          value: "ORDER",
        },
        {
          text: "Customer",
          value: "CUSTOMER",
        },
      ],
      typeOfNotificationOption: [
        {
          text: "Sms",
          value: "SMS",
        },
        {
          text: "Email",
          value: "EMAIL",
        },
        {
          text: "Whatsapp",
          value: "WHATSAPP",
        },
        {
          text: "Inapp",
          value: "INAPP",
        },
      ],
      notificationOption: {},
      templateOption: [],
      showPreviewHere: "",
      timestampDate: "",
      timestampTime: "",
      tempPreview: "",
      temp: {},
    };
  },

  computed: {
    ...mapGetters({
      getListOfEntities: "bulkNotification/GetListOfEntities",
      getNewCriteria: "bulkNotification/GetNewCriteria",
      getTemplateTypeList: "bulkNotification/GetTemplateTypeList",
      getPreviewTemplate: "bulkNotification/GetPreviewTemplate",
    }),
    templateOptionList() {
      const selectTemplate = this.getTemplateTypeList?.map((template) => ({
        text: template.concern,
        value: template?._id || "",
      }));
      return selectTemplate;
    },
    validStartDate() {
      if (!this.startDate) return false;
      if (moment().diff(this.startDate, "hour") <= 0) return false;
      return true;
    },
    validEndDate() {
      if (!this.endDate) return false;
      if (moment().diff(this.endDate, "hour") <= 0) return false;
      if (moment(this.endDate).diff(this.startDate, "day") <= 0) return false;
      return true;
    },
    criteriaOptions() {
      const optionList = this.getListOfEntities?.key?.map((entity) => {
        let result = entity.replace(/([A-Z])/g, " $1");
        let textValue = result.charAt(0).toUpperCase() + result.slice(1);
        return {
          text: textValue,
          value: entity,
        };
      });
      return optionList;
    },
    disableCriteria() {
      let allCriteria = this.selectedCriteriaOption?.map(
        (criteriaSelect) => criteriaSelect.value
      );
      return (
        this.selectedCriteriaOptions == "" ||
        (this.selectedCriteriaOptions?.value == "age" &&
          allCriteria.includes("age")) ||
        (this.selectedCriteriaOptions?.value == "date" &&
          allCriteria.includes("date")) ||
        (this.selectedCriteriaOptions?.value == "refererId" &&
          allCriteria.includes("refererId")) ||
          (this.selectedCriteriaOptions?.value == "orderAmount" &&
          allCriteria.includes("orderAmount"))
      );
    },
  },

  methods: {
    allOperatorOptions(option, index) {
      if (option.value == "date") {
        return (this.operatorOptions[index] = [
          {
            text: "Date",
            value: "date",
          },
        ]);
      } 
      if (option.value == "refererId") {
        return (this.operatorOptions[index] = [
          {
            text: "Equal (eq)",
            value: "equal",
          },
        ]);
      }
      if (option.value == "orderAmount") {
        return (this.operatorOptions[index] = [
          {
            text: "Range",
            value: "range",
          },
        ]);
      } else {
        return (this.operatorOptions[index] = [
          {
            text: "Equal (eq)",
            value: "equal",
          },
          {
            text: "Or",
            value: "or",
          },
        ]);
      }
    },
    async selectEntityType() {
      this.loading = true;
      this.selectedCriteriaOptions = "";
      this.selectedCriteriaOption = [];
      let payload = { label: this.entity.value };
      await this.$store.dispatch("bulkNotification/fetchEntities", payload);
      this.loading = false;
    },
    async viewImpactedCustomer() {
      const checkOperatorValue = [];
      this.selectedOperator.filter((operatorValue) =>
        checkOperatorValue.push(operatorValue.value)
      );
      if (
        checkOperatorValue.includes("or") == true &&
        checkOperatorValue.includes("equal") == false
      ) {
        this.$swal({
          title: "Select Valid Operator",
          text: "For Same Criteria, Select Operator 'Equal' for the First One.",
          type: "warning",
        });
      } else if (
        this.criteria.length > 0 &&
        this.selectedOperator.length > 0 &&
        this.inputData.length > 0 &&
        this.inputData.length === this.selectedOperator.length &&
        this.criteria.length === this.selectedOperator.length
      ) {
        let criteriaData = this.criteria?.map((obj, index) => {
          if (obj === "date") {
            if (
              !this.startDate || (moment().diff(this.startDate, "hour") <= 0) ||
              !this.endDate || (moment().diff(this.endDate, "hour") <= 0) ||
              (moment(this.endDate).diff(this.startDate, "day") <= 0)
            ) {
              return false;
            }
            return {
              field: obj,
              filter: this.selectedOperator[index]?.value || "",
              data: this.inputData[index],
            };
          } else if (obj === "orderAmount") {
            if (
              checkOperatorValue.includes("range") &&
              (!this.inputData[index].gte ||
                !this.inputData[index].lte ||
                parseInt(this.inputData[index].gte) >
                  parseInt(this.inputData[index].lte))
            ) {
              return false;
            }

            let rangevalue = {
              gte: parseInt(this.inputData[index].gte),
              lte: parseInt(this.inputData[index].lte),
            };
            return {
              field: obj,
              filter: this.selectedOperator[index]?.value || "",
              data: rangevalue,
            };
          } else {
            return {
              field: obj,
              filter: this.selectedOperator[index]?.value || "",
              data: {
                value: this.inputData[index],
              },
            };
          }
        });

        for (const temp of criteriaData)
          if (!temp) {
            this.$swal({
              title: "Invalid Range",
              text: "Please enter a valid range.",
              type: "error",
            });
            return;
          }
        let payload = {
          collectionName: this.getListOfEntities.label,
          filterBy: criteriaData,
          retriveParams: ["name", "email", "phone"],
          serviceUrl: this.getListOfEntities.serviceUrl,
          category: "PROMO",
        };
        this.loading = true;
        this.showloading();
        await this.$store
          .dispatch("bulkNotification/createCriteria", payload)
          .then((result) => {
            if (this.getNewCriteria.total !== 0) {
              this.$swal({
                title: "Successful",
                text: "Impacted Customer's List Fetched Successfully!",
                type: "success",
              }).then((result) => {
                this.$router.push("/bulkPromotion");
              });
            } else {
              this.$swal({
                title: "Error",
                text: "Criteria does not Match! Change Criteria and Try Again.",
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.$swal({
              title: "Sorry",
              text: "Unable to Fetch Impacted Customer's List",
              type: "error",
            });
          })
          .finally(() => (this.loading = false));
      } else {
        this.$swal({
          title: "Error",
          text: "Select All Fields",
          type: "error",
        });
      }
    },

    onMinRangeChange(minValue) {
      this.rangeValue.gte = minValue.srcElement._value + 1;
    },
    onMaxRangeChange(maxValue) {
      this.rangeValue.lte = maxValue.srcElement._value - 1;
    },

    addCriteriaData(selectedCriteriaOptions) {
      this.selectedCriteriaOption.push(selectedCriteriaOptions);
    },

    removeCriteria(index) {
      this.criteria.splice(index, 1);
      this.selectedOperator.splice(index, 1);
      this.inputData.splice(index, 1);
      this.selectedCriteriaOption.splice(index, 1);
    },

    showloading() {
      this.$swal({
        showConfirmButton: false,
        allowOutsideClick: false,
        title: "Loading...",
        text: "Loading your Data. Please Wait...",
        type: "info",
      });
    },

    selectDate() {
      if (this.startDate !== "" && this.endDate !== "") {
        this.startEndDate = {
          gte: this.startDate,
          lte: this.endDate,
        };
      }
    },

    downloadDetails() {
      if (this.getNewCriteria.total && this.getNewCriteria.total !== 0) {
        window.location = this.getNewCriteria.url;
      } else {
        this.$swal({
          title: "Error",
          text: "Data Not Available.",
          type: "error",
        });
      }
    },

    async templateTypeList() {
      this.templateOption = "";
      let payload = {
        service: this.notificationOption?.value || "",
      };
      await this.$store.dispatch(
        "bulkNotification/fetchTemplateTypeList",
        payload
      );
    },

    async previewSelectedTemplate() {
      let payload = {
        templateId: this.templateOption.value,
      };
      await this.$store.dispatch(
        "bulkNotification/fetchTemplateToPreview",
        payload
      );
      this.showPreviewHere = this.showPreview()
        .map((pre) => pre.body)
        .join("")
        .toString();
    },

    showPreview() {
      let previewTemplate = this.getPreviewTemplate?.filter(
        (preview) => preview.service == this.notificationOption.value
      );
      this.tempPreview = previewTemplate;
      return previewTemplate;
    },

    async createBulkNotification() {
      if (
        this.criteria.length > 0 &&
        this.selectedOperator.length > 0 &&
        this.inputData.length > 0 &&
        this.inputData.length === this.selectedOperator.length &&
        this.criteria.length === this.selectedOperator.length &&
        this.getNewCriteria.total !== 0 &&
        this.notificationOption.value &&
        this.templateOption.value
      ) {
        if (this.tempPreview[0].image) {
          this.temp = {
            _id: this.tempPreview[0]._id,
            name: this.tempPreview[0].service,
            concern: this.tempPreview[0].concern,
            body: this.tempPreview[0].body,
            subject: this.tempPreview[0]?.subject || "",
            image: this.tempPreview[0]?.image || "",
          };
        } else {
          this.temp = {
            _id: this.tempPreview[0]._id,
            name: this.tempPreview[0].service,
            concern: this.tempPreview[0].concern,
            body: this.tempPreview[0].body,
            subject: this.tempPreview[0]?.subject || "",
          };
        }
        let payload = {
          criteria: {
            filterBy: this.getNewCriteria.filterBy,
            retriveParams: this.getNewCriteria.retriveParams,
            status: this.getNewCriteria.status,
            collectionName: this.getNewCriteria.collectionName,
            serviceUrl: this.getNewCriteria.serviceUrl,
            tenant: this.getNewCriteria.tenant,
            count: this.getNewCriteria.total,
            url: this.getNewCriteria.url,
            _id: this.getNewCriteria._id,
          },
          notificationType: this.notificationOption.value,
          template: this.temp,
          description: this.description,
          promotionType: this.promoType,
          promotionAmount: this.promoAmount,
          scheduleDate: this.checkScheduleDate(),
        };
        await this.$store
          .dispatch("bulkNotification/createBulkNotification", payload)
          .then((result) => {
            this.$swal({
              title: "Successful",
              text: "Bulk Promotion Created Successfully!",
              type: "success",
            });
            this.$router.push("/listOfCriteria");
          })
          .catch((err) => {
            this.$swal({
              title: "Sorry",
              text: "Unable to Create Bulk Promotion!",
              type: "error",
            });
          });
      } else {
        this.$swal({
          title: "Error",
          text: "Select All Fields",
          type: "error",
        });
      }
    },
    checkScheduleDate() {
      if (this.timestampDate == "" && this.timestampTime == "") {
        return "";
      } else {
        return this.timestampDate + " " + this.timestampTime;
      }
    },
  },

  async mounted() {
  //   this.loading = true;
  //   let payload = { label: "CUSTOMER" };
  //   await this.$store.dispatch("bulkNotification/fetchEntities", payload);
  //   this.loading = false;
  },
};
</script>
<style scoped>
.previewTemplate {
  margin: 0;
  height: 150px;
  padding: 12px;
  border: 1px solid rgb(228, 214, 214);
  border-radius: 4px;
  min-width: 98%;
  overflow: auto;
}

.previewTemplate[contentEditable="false"]:empty:before {
  content: attr(placeholder);
}

.form-control {
  height: calc(2.2125rem + 8px);
}

.circularBtn {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  min-height: 40px !important;
  max-width: 40px !important;
  max-height: 40px !important;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  margin-left: auto;
  box-sizing: border-box;
  flex-shrink: 0;
}

.circularBtn i {
  font-size: 14px;
}


.cardStyle {
  border-radius: 16px;
}

.impactValueStyle {
  color: #33a02c;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f8f8;
  opacity: 1;
}

.impacted-cust {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  min-height: 40px;
  width: 100%;
  background-color: var(--secondary);
  color: #fff;
  border-radius: 0.25rem;
  padding: 0.375rem 0.75rem;
  font-weight: 500;
  box-sizing: border-box;
}

.select-background-white {
  background-color: #fff;
}

.age-row-padding {
  padding: 0px 20px;
}

.criteria-row {
  align-items: center;
  margin-bottom: 1rem;
}

.criteria-row >>> .form-group {
  margin-bottom: 0 !important;
}

.criteria-left-col >>> .vs__dropdown-toggle {
  height: calc(2.2125rem + 8px) !important;
  min-height: 38px !important;
}

.criteria-label {
  font-weight: 600;
  word-break: break-word;
}

@media (min-width: 768px) {
  .criteria-label-desktop {
    margin-top: 0;
    margin-bottom: 0;
    line-height: 38px;
  }
}

.order-amount-row {
  margin: 0;
  align-items: center;
}

.order-amount-col {
  flex: 1 1 0;
  min-width: 0;
}

.order-amount-col .form-control,
.order-amount-col .b-input {
  min-width: 0;
  width: 100%;
}

@media (min-width: 768px) {
  .order-amount-col {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .order-amount-col:first-child {
    padding-left: 0;
    padding-right: 0.25rem;
  }
  .order-amount-col:last-child {
    padding-left: 0.25rem;
    padding-right: 0;
  }
}

.impacted-buttons-row {
  align-items: stretch;
  gap: 12px;
}

@media (min-width: 768px) {
  .impacted-buttons-row {
    flex-wrap: nowrap;
  }
  .impacted-buttons-row > [class*="col"] {
    flex: 1 1 0;
    min-width: 0;
  }
}



.promo-config-row {
  align-items: flex-end;
  margin-bottom: 1.5rem;
}

.promo-config-row:last-of-type {
  margin-bottom: 1.5rem;
}

.timestamp-row {
  align-items: flex-end;
}

.submit-btn-custom {
  min-width: 160px;
}

.impactValueStyle {
  text-align: center;
}

.promo-config-card {
  margin-top: 0.5rem;
}

.section-title {
  margin-bottom: 2rem;
}

.section-subtitle {
  margin-bottom: 0.75rem;
}

.entity-criteria-top-row {
  align-items: center;
  margin-bottom: 1rem;
}

.entity-criteria-top-row >>> .form-group {
  margin-bottom: 0 !important;
}

.entity-criteria-top-row .circularBtn,
.entity-criteria-top-row .criteria-add-btn {
  margin-left: 0;
  flex-shrink: 0;
}

.entity-criteria-row {
  align-items: flex-start;
}


.impacted-buttons-row .btn {
  height: 40px;
  min-height: 40px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
}
.view-impacted-btn {
  width: auto;
  min-width: 0;
  white-space: nowrap;
}
.input-placeholder-right{
  margin-left: 0%;
}

.criteria-right-col .order-amount-row .form-control,
.criteria-right-col .date-input {
  height: calc(2.2125rem + 8px);
  min-height: 38px;
}

.criteria-right-col .row.align-items-center {
  align-items: center;
}

.criteria-right-col .criteria-minus-btn-col {
  align-self: center;
}

.criteria-row .form-control,
.criteria-row input[type="text"],
.criteria-row input[type="number"],
.criteria-row .criteria-input {
  min-height: 38px;
  height: 38px;
}

.criteria-row .criteria-input-col .form-control {
  height: 38px;
  min-height: 38px;
}

.date-inputs-row {
  margin-bottom: 0;
  margin-top: -4px;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.date-inputs-row .date-input-col {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
  min-width: 0;
}

.date-inputs-row .date-input,
.date-inputs-row .form-control,
.criteria-row .date-inputs-row .form-control {
  height: 38px;
  min-height: 38px;
}

.criteria-row .order-amount-row .form-control,
.criteria-row .order-amount-row .b-input {
  height: 38px;
  min-height: 38px;
}
.promo-input {
  height: calc(2.2125rem + 8px);
  min-height: 38px;
}

@media (max-width: 767.98px) {
  .download-btn-right {
    float: none;
    width: 100%;
  }

  .age-row-padding {
    padding: 0px 10px;
  }

  .criteria-label {
    font-size: 0.9rem;
  }

  .previewTemplate {
    margin: 0;
    min-width: 100%;
    font-size: 0.875rem;
  }

  .impactValueStyle {
    font-size: 0.95rem;
  }

  .section-title {
    font-size: 1rem;
    margin-bottom: 2rem !important;
  }

  .promo-config-row {
    margin-bottom: 2rem !important;
  }

  .promo-config-card .promo-config-row [class*="col-"] {
    margin-bottom: 1rem !important;
  }

  .promo-config-card .timestamp-row [class*="col-"] {
    margin-bottom: 1rem !important;
  }

  .impacted-buttons-row {
    gap: 1rem;
  }

  .date-inputs-row {
    flex-wrap: wrap;
  }

  .date-inputs-row .date-input-col:first-child {
    margin-bottom: 1rem;
  }
}
@media (max-width: 575.98px) {
  .circularBtn {
    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;
    max-width: 40px !important;
    max-height: 40px !important;
    border-radius: 50%;
    padding: 0 !important;
  }

  .circularBtn::after {
    display: none;
  }
}
::v-deep .vs__dropdown-toggle {
  height: 38px !important;
  min-height: 38px;
  display: flex;
  align-items: center;
}

::v-deep .form-group {
  margin-bottom: 0 !important;
}
.promo-config-row {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
}

.promo-config-row .form-control,
.promo-config-row .vs__dropdown-toggle {
  height: 38px !important;
}
</style>
